/**
 * 通用提示弹框组件
 * Created by qingqing.yang
 */

import React from 'react';
import { Icon } from '@ok/okd';

/**
 * 接收参数
 * className: 当前气泡组件的类名
 * title:  气泡提示的标题
 * tips:   气泡提示
 */
export default function PopTip({ className, title, tips }) {
  return (
    <div className={`pop-tip-div ${className}`}>
      <Icon className="okds-information-circle-fill f-12" />
      {title && <span className="f-14">{title}</span>}
      {tips &&
        tips.length > 0 &&
        tips.map((item, key) => {
          return (
            <p key={key} className="f-12">
              {item}
            </p>
          );
        })}
    </div>
  );
}
